import Vue from 'vue';

export const getFormSectionsByTicket = async ({ commit }, ticketId) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/formSections/ticket/${ticketId}`
    });
    return { status: true, data };
  } catch (error) {
    return { message: error, status: false };
  }
};

export const getFormSectionsByAffiliationType = async ({ commit }, affiliationTypeId) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/formSections/affiliation-type/${affiliationTypeId}`
    });
    return { status: true, data };
  } catch (error) {
    return { message: error, status: false };
  }
};

export const getFormSectionsByOrg = async ({ commit }, organizationId) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/formSections/form/${organizationId}`
    });
    return { status: true, data };
  } catch (error) {
    return { message: error, status: false };
  }
};

export const addFormSection = async ({ commit }, payload) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: '/formSections',
      data: { section: payload }
    });
    return { status: true, data };
  } catch (error) {
    return { message: error, status: false };
  }
};

export const updateFormSection = async ({ commit }, { id, payload }) => {
  try {
    const { data } = await Vue.axios({
      method: 'PUT',
      url: `/formSections/${id}`,
      data: { section: payload }
    });
    return { status: true, data };
  } catch (error) {
    return { message: error, status: false };
  }
};

export const deleteFormSection = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      method: 'DELETE',
      url: `/formSections/${id}`
    });
    return { status: true, data };
  } catch (error) {
    return { message: error, status: false };
  }
};
